import React, { useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import {  Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { getPageContents } from "../../../actions/admin/cmspage";
import { useLoading } from "../../../components/LoadingContext";
import {
  CustomizationIcon,
  ProductivityIcon,
  PeaceOfMindIcon,
  PrivacyIcon,
  CommunicationIcon,
  ProfessionalismIcon,
  ArrowRightIcon,
} from "../../../components/icons";

const ExecutiveTransfer = () => {
  const page_name = "cms-executive-transfer";
  const dispatch = useDispatch();
  const history = useHistory();
  const cmspage_state = useSelector((state) => state.cmspage);
  const { cmspage, loading } = cmspage_state;
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.toUpperCase();
  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);
  const { showLoading, closeLoading } = useLoading();
  return (
    <FrontLayout>
    {loading ? showLoading(true) : closeLoading(true)}
      <div
        className="hero-image-executive-transfer tw:flex tw:items-end"
        style={{
          background:
            "url('" +
            (lang === "EN"
              ? cmspage?.page_content_en.image1
              : cmspage?.page_content_jp.image1) +
            "')",
        }}
      >
        <div className="custom-pt-8 tw:w-full tw:mx-auto tw:px-3 tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:lg:w-3/4 tw:mb-4 tw:pb-4 tw:md:pb-12">
          <div className="tw:w-full tw:flex tw:flex-col tw:justify-end">
            <p
              className="text-gold tw:bg-transparent tw:border-0 tw:py-2 tw:pr-4 tw:pl-0 tw:mb-0! tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content1
                    : cmspage?.page_content_jp.content1,
              }}
            >
              {/* {t("Services")} */}
            </p>
            <h1
              className="tw:font-bold! tw:mb-6 tw:mt-2"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content2
                    : cmspage?.page_content_jp.content2,
              }}
            >
              {/* {t("Executive.Transfer")} */}
            </h1>
            <p
              className="text-gold intro tw:w-full tw:md:w-[58.3333%] tw:mb-12 tw:lg:mb-0"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content3
                    : cmspage?.page_content_jp.content3,
              }}
            >
              {/* {t("ExecutiveTransfer.Intro")} */}
            </p>
          </div>
        </div>
      </div>
      {/* <!-- service type nav --> */}
      <div className="border-bottom-gold tw:w-full tw:mx-auto tw:px-3">
        <div className="tw:md:mx-4">
          <ul className="horizontal-scrollable tw:md:w-[91.6667%] tw:lg:w-3/4 tw:mx-auto tw:text-center tw:border-0 tw:flex tw:flex-row tw:pl-0 tw:mb-0! tw:list-none">
            <li className="tw:mt-auto">
              <Link
                className="nav-link-light-bg-alt me-4-custom-breakpoint tw:block tw:px-4 tw:py-6 tw:no-underline!"
                to="./airport-transfer"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content4
                      : cmspage?.page_content_jp.content4,
                }}
              ></Link>
            </li>

            {/* <li className="tw:mt-auto">
              <Link
                className="nav-link-light-bg-alt me-4-custom-breakpoint tw:block tw:px-4 tw:py-6 tw:no-underline!"
                to="./weddings-anniversaries"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content5
                      : cmspage?.page_content_jp.content5,
                }}
              >
              </Link>
            </li> */}

            <li className="tw:mt-auto">
              <Link
                className="nav-link-light-bg-alt me-4-custom-breakpoint tw:block tw:px-4 tw:py-6 tw:no-underline!"
                to="./private-tour"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content6
                      : cmspage?.page_content_jp.content6,
                }}
              >
                {/* {t("Private.Tour")} */}
              </Link>
            </li>

            <li className="tw:mt-auto">
              <Link
                className="nav-link-light-bg-alt me-4-custom-breakpoint active tw:block tw:px-4 tw:py-6 tw:no-underline!"
                aria-current="page"
                to="./executive-transfer"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content7
                      : cmspage?.page_content_jp.content7,
                }}
              >
                {/* {t("Executive.Transfer")} */}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {/* <!-- service type nav --> */}
      {/* <!-- section 1 --> */}
      <div className="tw:w-full tw:mx-auto tw:px-3 tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:lg:w-3/4 tw:mt-12 tw:lg:mt-4 tw:mb-0! tw:md:mb-12 tw:md:pt-12 tw:md:pb-2">
        <div className="tw:flex tw:flex-wrap">
          <div className="tw:flex-1 tw:basis-0 tw:px-3 tw:lg:flex-none tw:lg:w-[83.3333%] tw:lg:ml-[8.3333%]">
            <p
              className="tw:text-[#212529]!"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content8
                    : cmspage?.page_content_jp.content8,
              }}
            >
              {/* {t("ExecutiveTransfer.Intro.Additional")} */}
            </p>
            <h6
              className="intro tw:text-[#212529]! tw:py-4"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content9
                    : cmspage?.page_content_jp.content9,
              }}
            >
              {/* {t("ExecutiveTransfer.Intro.Golf")} */}
            </h6>
            <ul>
              <li
                className="tw:text-[#212529]! tw:my-1"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content10
                      : cmspage?.page_content_jp.content10,
                }}
              >
                {/* {t("ExecutiveTransfer.Intro.Additional.Point")} */}
              </li>
            </ul>
            <h6
              className="intro tw:text-[#212529]! tw:py-4"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content11
                    : cmspage?.page_content_jp.content11,
              }}
            >
              {/* {t("ExecutiveTransfer.Intro.Additional.Point.Description")} */}
            </h6>
          </div>
        </div>
        <div className="tw:flex tw:flex-wrap">
          <div className="tw:flex-1 tw:basis-0 tw:px-3 tw:lg:flex-none tw:lg:w-[83.3333%] tw:lg:ml-[8.3333%]">
            <p
              className="tw:text-[#212529]!"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content12
                    : cmspage?.page_content_jp.content12,
              }}
            >
              {/* {t("ExecutiveTransfer.Paragraph.One")} */}
            </p>
            <h6
              className="intro tw:text-[#212529]! tw:py-4"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content13
                    : cmspage?.page_content_jp.content13,
              }}
            >
              {/* {t("ExecutiveTransfer.Paragraph.Two")} */}
            </h6>
            <p
              className="tw:text-[#212529]!"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content14
                    : cmspage?.page_content_jp.content14,
              }}
            >
              {/* {t("ExecutiveTransfer.Paragraph.Three")} */}
            </p>
            <h6
              className="intro tw:text-[#212529]! tw:py-4"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content15
                    : cmspage?.page_content_jp.content15,
              }}
            >
              {/* {t("ExecutiveTransfer.Paragraph.Four")} */}
            </h6>
            <p className="tw:text-[#212529]!">
              {t("ExecutiveTransfer.Paragraph.Five")}&nbsp;
              <Link
                to="./contact"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content16
                      : cmspage?.page_content_jp.content16,
                }}
              >
                {/* {t("Urgent.Inquiries")} */}
              </Link>
            </p>
          </div>
        </div>
      </div>
      {/* <!-- section 1 end --> */}
      {/* <!-- section 4 why us --> */}
      <div className="tw:flex tw:flex-wrap tw:mt-12 tw:md:mb-4 tw:items-center">
        <div className="tw:flex-1 tw:basis-0 tw:px-0">
          <hr />
        </div>
        <div className="tw:w-auto tw:flex-none tw:px-3 tw:text-center">
          <h3
            dangerouslySetInnerHTML={{
              __html:
                lang === "EN"
                  ? cmspage?.page_content_en.content17
                  : cmspage?.page_content_jp.content17,
            }}
          >
            {/* {t("ExecutiveTransfer.Heading.Two")} */}
          </h3>
        </div>
        <div className="tw:flex-1 tw:basis-0 tw:px-0">
          <hr />
        </div>
      </div>
      {/* <!-- section 4 why us cards --> */}
      <div className="tw:w-full tw:mx-auto tw:px-3 tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-4 tw:md:mt-6 tw:md:mb-12 tw:py-12">
        <div className="tw:flex tw:flex-wrap tw:gap-y-6 tw:mb-6">
          <div className="tw:w-full tw:px-3 tw:md:w-1/2 tw:lg:w-1/3">
            <div className="why-us-card tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:flex-1 tw:basis-0 tw:md:flex-none tw:md:basis-auto tw:md:w-1/4 tw:lg:w-auto tw:flex tw:items-center">
                      <CustomizationIcon
                        className="tw:w-full tw:h-auto"
                        aria-label="Customization"
                        role="img"
                      />
                    </div>
                    <div className="tw:w-full tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5
                        className="tw:text-[1.25rem]! tw:mb-0!"
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content18
                              : cmspage?.page_content_jp.content18,
                        }}
                      >
                        {/* {t("ExecutiveTransfer.Heading.Two.Card.One")} */}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p
                    className="tw:pt-4 tw:mb-0!"
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === "EN"
                          ? cmspage?.page_content_en.content19
                          : cmspage?.page_content_jp.content19,
                    }}
                  >
                    {/* {t("ExecutiveTransfer.Heading.Two.Card.One.Description")} */}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="tw:w-full tw:px-3 tw:md:w-1/2 tw:lg:w-1/3">
            <div className="why-us-card tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:flex-1 tw:basis-0 tw:md:flex-none tw:md:basis-auto tw:md:w-1/4 tw:lg:w-auto tw:flex tw:items-center">
                      <ProductivityIcon
                        className="tw:w-full tw:h-auto"
                        aria-label="Productivity"
                        role="img"
                      />
                    </div>
                    <div className="tw:w-full tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5
                        className="tw:text-[1.25rem]! tw:mb-0!"
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content20
                              : cmspage?.page_content_jp.content20,
                        }}
                      >
                        {/* {t("ExecutiveTransfer.Heading.Two.Card.Two")} */}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p
                    className="tw:pt-4 tw:mb-0!"
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === "EN"
                          ? cmspage?.page_content_en.content21
                          : cmspage?.page_content_jp.content21,
                    }}
                  >
                    {/* {t("ExecutiveTransfer.Heading.Two.Card.Two.Description")} */}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="tw:w-full tw:px-3 tw:md:w-1/2 tw:lg:w-1/3">
            <div className="why-us-card tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:flex-1 tw:basis-0 tw:md:flex-none tw:md:basis-auto tw:md:w-1/4 tw:lg:w-auto tw:flex tw:items-center">
                      <PeaceOfMindIcon
                        className="tw:w-full tw:h-auto"
                        aria-label="Peace of mind"
                        role="img"
                      />
                    </div>
                    <div className="tw:w-full tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5
                        className="tw:text-[1.25rem]! tw:mb-0!"
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content22
                              : cmspage?.page_content_jp.content22,
                        }}
                      >
                        {/* {t("ExecutiveTransfer.Heading.Two.Card.Three")} */}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p
                    className="tw:pt-4 tw:mb-0!"
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === "EN"
                          ? cmspage?.page_content_en.content23
                          : cmspage?.page_content_jp.content23,
                    }}
                  >
                    {/* {t("ExecutiveTransfer.Heading.Two.Card.Three.Description")} */}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="tw:w-full tw:px-3 tw:md:w-1/2 tw:lg:w-1/3">
            <div className="why-us-card tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:flex-1 tw:basis-0 tw:md:flex-none tw:md:basis-auto tw:md:w-1/4 tw:lg:w-auto tw:flex tw:items-center">
                      <PrivacyIcon
                        className="tw:w-full tw:h-auto"
                        aria-label="Privacy"
                        role="img"
                      />
                    </div>
                    <div className="tw:w-full tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5
                        className="tw:text-[1.25rem]! tw:mb-0!"
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content24
                              : cmspage?.page_content_jp.content24,
                        }}
                      >
                        {/* {t("ExecutiveTransfer.Heading.Two.Card.Four")} */}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p
                    className="tw:pt-4 tw:mb-0!"
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === "EN"
                          ? cmspage?.page_content_en.content25
                          : cmspage?.page_content_jp.content25,
                    }}
                  >
                    {/* {t("ExecutiveTransfer.Heading.Two.Card.Four.Description")} */}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="tw:w-full tw:px-3 tw:md:w-1/2 tw:lg:w-1/3">
            <div className="why-us-card tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:flex-1 tw:basis-0 tw:md:flex-none tw:md:basis-auto tw:md:w-1/4 tw:lg:w-auto tw:flex tw:items-center">
                      <CommunicationIcon
                        className="tw:w-full tw:h-auto"
                        aria-label="Communication and manners"
                        role="img"
                      />
                    </div>
                    <div className="tw:w-full tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5
                        className="tw:text-[1.25rem]! tw:mb-0!"
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content26
                              : cmspage?.page_content_jp.content26,
                        }}
                      >
                        {/* {t("ExecutiveTransfer.Heading.Two.Card.Five")} */}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p
                    className="tw:pt-4 tw:mb-0!"
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === "EN"
                          ? cmspage?.page_content_en.content27
                          : cmspage?.page_content_jp.content27,
                    }}
                  >
                    {/* {t("ExecutiveTransfer.Heading.Two.Card.Five.Description")} */}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="tw:w-full tw:px-3 tw:md:w-1/2 tw:lg:w-1/3">
            <div className="why-us-card tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:h-full">
              <div className="tw:flex tw:flex-col tw:items-start">
                <div className="tw:flex-1 tw:p-4 tw:flex tw:flex-col tw:lg:flex-row tw:pb-0 tw:items-start">
                  <div className="tw:flex tw:items-center">
                    <div className="tw:flex-1 tw:basis-0 tw:md:flex-none tw:md:basis-auto tw:md:w-1/4 tw:lg:w-auto tw:flex tw:items-center">
                      <ProfessionalismIcon
                        className="tw:w-full tw:h-auto"
                        aria-label="Professionalism"
                        role="img"
                      />
                    </div>
                    <div className="tw:w-full tw:md:w-3/4 tw:md:flex-none tw:lg:flex-1 tw:lg:basis-0 tw:pl-4 tw:lg:pl-6 tw:flex tw:items-center">
                      <h5
                        className="tw:text-[1.25rem]! tw:mb-0!"
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content28
                              : cmspage?.page_content_jp.content28,
                        }}
                      >
                        {/* {t("ExecutiveTransfer.Heading.Two.Card.Six")} */}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="tw:flex-1 tw:p-4">
                  <hr className="card-line-dark"></hr>
                  <p
                    className="tw:pt-4 tw:mb-0!"
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === "EN"
                          ? cmspage?.page_content_en.content29
                          : cmspage?.page_content_jp.content29,
                    }}
                  >
                    {/* {t("ExecutiveTransfer.Heading.Two.Card.Six.Description")} */}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- section 4 why us end --> */}
      {/* <!-- banner --> */}
      <div
        className="cta-banner-services tw:w-full tw:mx-auto tw:px-3"
        style={{
          background:
            "url('" +
            (lang === "EN"
              ? cmspage?.page_content_en.image2
              : cmspage?.page_content_jp.image2) +
            "')",
        }}
      >
        <div className="tw:w-full tw:mx-auto tw:px-3 tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:lg:w-3/4">
          <div className="tw:flex tw:flex-wrap tw:-mx-3">
            <div className="tw:flex-1 tw:basis-0 tw:px-3 tw:pb-6 tw:pt-12 tw:mb-6 tw:mt-12 tw:flex tw:flex-col tw:justify-center">
              <div className="tw:mb-2 tw:mt-12 tw:md:mt-0">
                <h3
                  className="text-gold"
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "EN"
                        ? cmspage?.page_content_en.content30
                        : cmspage?.page_content_jp.content30,
                  }}
                >
                  {/* {t("CTA.Banner.Alt.Heading")} */}
                </h3>
              </div>

              <h6
                className="text-gold intro tw:w-full tw:md:w-[58.3333%] tw:mb-6"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content31
                      : cmspage?.page_content_jp.content31,
                }}
              >
                {/* {t("CTA.Banner.Alt.Intro")} */}
              </h6>

              <div className="tw:grid tw:gap-2 tw:md:block tw:mt-auto">
                <button
                  onClick={() => history.push("./book")}
                  type="button"
                  className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline! tw:align-middle tw:cursor-pointer tw:select-none tw:text-[1.25rem] tw:rounded-[0.5rem] tw:px-12 tw:py-2 tw:md:mr-2 tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:bg-[#d4b055] tw:border tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:disabled:opacity-65 tw:disabled:pointer-events-none"
                >
                  <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                    {/* {t("Book.Now")} */}
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          lang === "EN"
                            ? cmspage?.page_content_en.content32
                            : cmspage?.page_content_jp.content32,
                      }}
                    ></div>
                    <i className="tw:pl-2">
                     <ArrowRightIcon color="#4A4A4A" size={24} />
                    </i>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FrontLayout>
  );
};

export default ExecutiveTransfer;
